<template>
  <div class="flex flex-wrap py-4">
    <button
      class="rounded mr-2 px-3 py-1 border border-gray-300 hover:border-gray-600 mb-1"
      @click="$emit('toggle')"
    >Filters</button>
    <button
      v-for="key in usedFilters"
      :key="key"
      class="bg-gray-800 rounded px-2 py-1 text-white mr-2 flex items-center mb-1"
      @click="filters[key] = ''"
    >
      <span class="mx-1 truncate max-w-xs">{{ filterToText(key) }}</span>
      <BaseIcon name="x" size="16" />
    </button>
    <div class="text-gray-300 self-center mb-1" v-if="!usedFilters.length">Geen filters toegepast</div>
    <button v-else class="hover:text-black px-1 mb-1 flex items-center" @click="$emit('clear')">
      <BaseIcon name="x" /><span class="hidden md:inline">Opheffen</span>
    </button>
  </div>
</template>

<script>
import { removeEmptyKeys } from "@/functions.js";

export default {
  props: {
    filters: {
      type: Object,
      required: true
    },
    filterOptions: {
      type: Object,
      required: true
    }
  },

  computed: {
    usedFilters() {
      return Object.keys(removeEmptyKeys(this.filters));
    }
  },

  methods: {
    filterToText(filterKey) {
      let options = this.filterOptions[filterKey];
      let value = this.filters[filterKey];

      if (options) {
        for (let option of options) {
          if (option.value == value) {
            return option.text;
          }
        }
      } else {
        return value;
      }
    }
  }
};
</script>
